import { Box, Button, Card } from '@mui/material'

import { useEffect, useState } from 'react'
import WTypography from 'Components/whiteTypography'
import { Doughnut } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

function MonPatrimoineCard({ oldData, updateReports }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [actifs, setActifs] = useState(true)
  const [total, setTotal] = useState(0)
  const [revData, setRevData] = useState({
    labels: [],

    datasets: [
      {
        data: [],
        backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
        borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
        borderWidth: 1,
        hoverOffset: 4,
        precision: 0,
      },
    ],
  })
  const optiondonut = {
    responsive: true,
    aspectRatio: 1.3,
    clip: true,
    cutout: '0%',
    plugins: {
      datalabels: {
        formatter: function (value, ctx) {
          return ctx.chart.data.labels[ctx.dataIndex] + '\n' + [parseFloat(value).toFixed(2) + '%']
        },
        textAlign: 'center',
        color: 'white',
        anchor: 'center',
        clamp: true,
        display: 'auto',
      },

      legend: {
        display: true,
        position: 'bottom',
        responsive: true,
        events: [],
        labels: {
          boxWidth: 10,
          color: 'white',
        },
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem) {
            return tooltipItem.yLabel
          },
        },
      },
    },
  }

  useEffect(() => {
    setTotal(oldData?.actifs?.total)
    setRevData({
      labels: oldData?.actifs?.labels,
      datasets: [
        {
          data: oldData?.actifs?.data,

          backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
          borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
          borderWidth: 1,
          hoverOffset: 4,
          precision: 0,
        },
      ],
    })
  }, [oldData])
  const handelMon = (val) => {
    if (val) {
      setTotal(oldData?.actifs?.total)
      setRevData({
        labels: oldData?.actifs?.labels,
        datasets: [
          {
            data: oldData?.actifs?.data,

            backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
            borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
            borderWidth: 1,
            hoverOffset: 4,
            precision: 0,
          },
        ],
      })
    } else {
      setTotal(oldData?.passifs?.total)
      setRevData({
        labels: oldData?.passifs?.labels,
        datasets: [
          {
            data: oldData?.passifs?.data,

            backgroundColor: ['#93b7ff', '#6087cd', '#295a9c'],
            borderColor: ['#93b7ff', '#6087cd', '#295a9c'],
            borderWidth: 1,
            hoverOffset: 4,
            precision: 0,
          },
        ],
      })
    }
    setActifs(val)
  }
  return (
    <>
      <Card className="dashboard_card__root1">
        <Box className="dashboard_card__header1">
          <WTypography component={'span'} variant="h6">
            {actifs ? t('monPatrimoine.myPatrimoine') : t('monPatrimoine.patrimoine')}
          </WTypography>
          <WTypography component={'span'} variant="h6">
            {total}

            <WTypography
              component={'span'}
              sx={{ fontSize: '12px', color: 'white', marginLeft: '4px' }}
            >
              €
            </WTypography>
          </WTypography>
        </Box>
        <Box className="dashboard_card__header1">
          <WTypography sx={{ color: '#ffffffa1' }} variant={'body2'}>
            {actifs ? t('monPatrimoine.distributionOfAssets') : t('monPatrimoine.distributionOfLiabilities')}
          </WTypography>
        </Box>

        <Box minWidth={3} mb={8} height={'70%'}>
          <Box mt={9} className="chart_box no-drag" minWidth={3} mb={6} height={'100%'}>
            <Doughnut data={revData} options={optiondonut} />
          </Box>
        </Box>
        <Box mt={2} pb={1} sx={{ right: '32% !important' }} className="dashboard_card__filters1">
          <Box
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            className="no-drag"
          >
            <Button
              variant=""
              onClick={() => handelMon(true)}
              sx={{ color: actifs ? '#305fb5' : 'white' }}
            >
              {t('monPatrimoine.myAssets')}
            </Button>
            <Button
              variant=""
              onClick={() => handelMon(false)}
              sx={{ color: actifs ? 'white' : '#305fb5' }}
            >
              {t('monPatrimoine.myLiabilities')}
            </Button>
          </Box>
        </Box>
      </Card>
    </>
  )
}

export default MonPatrimoineCard
